import { DEFAULT_LOCALE, isSupportedLocale, SupportedLocale } from './locales';

const LOCALE_SHAPED_SEGMENT = /^[a-z]{2}(-[a-z]{2,4})?$/i;

export interface ResolvedLocale {
  locale: SupportedLocale;
  redirectTo: string | null;
}

const detectLocale = (preferred: readonly string[]): SupportedLocale => {
  for (const tag of preferred) {
    const lower = tag.toLowerCase();
    if (isSupportedLocale(lower)) return lower;
    const base = lower.split('-')[0];
    if (isSupportedLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
};

export const resolveLocale = (
  pathname: string,
  search: string,
  preferred: readonly string[] = [],
): ResolvedLocale => {
  const segments = pathname.split('/').filter(Boolean);
  const first = segments[0] ?? '';

  if (isSupportedLocale(first)) {
    return { locale: first, redirectTo: null };
  }

  const isLocaleShaped = LOCALE_SHAPED_SEGMENT.test(first);
  const locale = isLocaleShaped ? detectLocale([first, ...preferred]) : detectLocale(preferred);
  const rest = isLocaleShaped ? segments.slice(1) : segments;
  const restPath = rest.length ? `/${rest.join('/')}` : '/';

  return { locale, redirectTo: `/${locale}${restPath}${search}` };
};
